package com.partejar.app.feature.convite.presentation

import io.ktor.http.decodeURLQueryComponent

object ConviteLinkParser {
    fun tokenFrom(link: String): String? = PublicWebLinkParser.fragmentToken(link, "invite")
        ?: PublicWebLinkParser.queryToken(link, "invite")
        ?: PublicWebLinkParser.queryToken(link, "token")
}

sealed interface PublicWebLinkRoute {
    data object Normal : PublicWebLinkRoute
    data class Invite(val link: String) : PublicWebLinkRoute
    data class Signature(val token: String) : PublicWebLinkRoute
}

object PublicWebLinkParser {
    fun routeFrom(url: String): PublicWebLinkRoute = when {
        fragmentToken(url, "invite") != null -> PublicWebLinkRoute.Invite(url)
        fragmentToken(url, "signature") != null -> PublicWebLinkRoute.Signature(
            fragmentToken(url, "signature").orEmpty()
        )
        hasQueryParameter(url, "invite") -> PublicWebLinkRoute.Invite(url)
        hasQueryParameter(url, "signature") -> PublicWebLinkRoute.Signature(
            queryToken(url, "signature").orEmpty()
        )
        hasLegacySignaturePath(url) -> PublicWebLinkRoute.Signature(
            legacySignatureToken(url).orEmpty()
        )
        else -> PublicWebLinkRoute.Normal
    }

    fun queryToken(url: String, name: String): String? = rawQueryParameter(url, name)
        ?.let(::decode)
        ?.takeIf(::isValidToken)

    fun fragmentToken(url: String, name: String): String? = url.substringAfter('#', "")
        .split('&')
        .firstOrNull { part -> decode(part.substringBefore('=')) == name }
        ?.substringAfter('=', "")
        ?.let(::decode)
        ?.takeIf(::isValidToken)

    private fun hasQueryParameter(url: String, name: String): Boolean = rawQuery(url)
        .split('&')
        .any { part -> decode(part.substringBefore('=')) == name }

    private fun rawQueryParameter(url: String, name: String): String? = rawQuery(url)
        .split('&')
        .firstOrNull { part -> decode(part.substringBefore('=')) == name }
        ?.substringAfter('=', "")

    private fun rawQuery(url: String): String = url.substringAfter('?', "")
        .substringBefore('#')

    private fun hasLegacySignaturePath(url: String): Boolean = path(url)
        .contains(LEGACY_SIGNATURE_PATH)

    private fun legacySignatureToken(url: String): String? = path(url)
        .substringAfter(LEGACY_SIGNATURE_PATH, "")
        .substringBefore('/')
        .takeIf(::isValidToken)

    private fun path(url: String): String = url.substringBefore('?').substringBefore('#')

    private fun decode(value: String): String? = runCatching {
        value.decodeURLQueryComponent(plusIsSpace = true)
    }.getOrNull()

    private fun isValidToken(value: String): Boolean = value.matches(TOKEN_PATTERN)

    private const val LEGACY_SIGNATURE_PATH = "/assinaturas/contratos/"
    private val TOKEN_PATTERN = Regex("[A-Za-z0-9_-]+")
}
